import { ImageElement, Element, FooterElement, HeaderElement } from 'features/document/constants';
import _ from 'lodash';
import { Template } from 'features/document/documentSlice';
import { isElementWithFile } from './typeGuards';

export const findElementsWithImage = (template: Template): (ImageElement | FooterElement | HeaderElement)[] => {
  const allElements: Element[] = _.flatMapDeep(template.pages, page => [
    page.header,
    page.rows.flatMap(row => row.columns.flatMap(column => column.elements)),
    page.footer,
  ]);

  const elementsWithImages = allElements.filter(isElementWithFile);
  return elementsWithImages;
};

export const getPagesFilesId = (template: Template): { id: number }[] => {
  return template.pages
    .filter(page => page.backgroundImageId !== undefined)
    .map(page => ({ id: Number(page.backgroundImageId) }));
};
